// extracted by mini-css-extract-plugin
export default {"scrollableArea":"HorizontalScrollableArea_scrollableArea__5TyAP"};